/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { verifyEmployeeInput } from './DataActionExtension.g';

/**
 * ValidationFormEmployee Input Action
 */

export class ValidationFormEmployeeInput implements Msdyn365.IActionInput {
    public input: IDataServiceRequest;
    constructor(input: IDataServiceRequest) {
        this.input = input;
    }

    public shouldCacheOutput = () => { return false; };
    public getCacheKey = () => `IValidationFormEmployee`;
    public getCacheObjectType = () => 'IValidationFormEmployee';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IValidationFormEmployeeData {
    text: string;
}

export type validationFormEmployeeInfo = {
    employeeId: string;
    lastName: string;
    birthYear: string;
    customerId: string;
};

/**
 * TODO: Use this function to create the input required to make the action call
 */
export const createEmployeeValidationInput = (inputData: validationFormEmployeeInfo, appContext: Msdyn365.ICoreContext<{ [x: string]: unknown }>): ValidationFormEmployeeInput => {
    return new ValidationFormEmployeeInput(
        verifyEmployeeInput(
            inputData.customerId,
            inputData.employeeId,
            inputData.lastName,
            inputData.birthYear
        )
    );
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function employeeValidationAction(input: ValidationFormEmployeeInput, ctx: Msdyn365.IActionContext): Promise<IValidationFormEmployeeData> {
    return input.input.execute(ctx);
}

export const IValidationFormEmployeeAction = Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IValidationFormEmployeeData>>employeeValidationAction,
    input: createEmployeeValidationInput
});
